var $ = require('jquery');
var siteadmin = require('../siteadmin');
var api = require('../api');

(function() {

    var self = this;

    self.errorDelay = 5000; // delay in msec to wait for postmessage event
    self.timeoutId = null;
    self.loader = null;
    self.iframe = null;
    self.errorContainer = null;
    // the catalog should use window.postMessage() to send the string defined below
    // to confirm it has loaded correctly
    self.expectedMessageData = '1and1-apps-catalog';
    // flag to define if any message was received to prevent parallel execution of event handlers
    self.messageReceived = false;

    self.controllerLoaded = false;

    this.afterFillContent = function(el, data, contentElement) {

//        diy.editor.siteadmin.api.updateHelpTopic('');

        self.loader = $('#cc-sa-apps-catalog-loading', contentElement);
        self.iframe = $('#cc-sa-apps-catalog-iframe', contentElement);
        self.errorContainer = $('#cc-sa-apps-catalog-error', contentElement);

        // whether to check for a message sent from the catalog iframe
        var checkEnabled = parseInt(self.loader.attr('data-check-enabled'), 10);
        var catalogUrl = self.loader.attr('data-catalog-url');
        if (catalogUrl) {
            if (checkEnabled) {
                // listen for success message from catalog iframe
                $(window).bind('message.catalogCrossOrigin', function(event) {
                    self.messageReceived = true;
                    if (event.originalEvent && event.originalEvent.data) {
                        // check that the message is the expected string
                        var messageData = event.originalEvent.data;
                        if (messageData == self.expectedMessageData) {
                            if (self.timeoutId) {
                                clearTimeout(self.timeoutId);
                                self.timeoutId = null;
                            }
                            self.showCatalog();
                            $(window).unbind('.catalogCrossOrigin');
                        } else {
                            self.scheduleErrorDisplay();
                        }
                    } else {
                        self.scheduleErrorDisplay();
                    }
                });
            }

            var loadHandler;
            // if the catalog is expected to send a message on load, set a timeout to display the error
            // if not, display the iframe immediately after load
            if (checkEnabled) {
                loadHandler =  function(event) {
                    // set a timeout only if the iframe loaded and it hasn't yet sent a message
                    if (!self.messageReceived) {
                        self.scheduleErrorDisplay();
                    }
                };
            } else {
                loadHandler = self.showCatalog;
            }

            var sentParams = siteadmin.getParams();
            if ($.isPlainObject(sentParams) && sentParams.openTo == 'yourIndustryRecommended') {
                catalogUrl += '#/list/recommendation';
                api.disableCache();
            }

            self.iframe.load(loadHandler);

            self.iframe.attr('src', catalogUrl);
        } else {
            self.showError();
        }

        self.controllerLoaded = true;

    };

    this.allowSwitch = function()
    {
        return self.controllerLoaded;
    };

    this.showCatalog = function () {
        self.loader.hide();
        self.errorContainer.hide();
        self.iframe.show();
        self.iframe.css('visibility', 'visible');
        $(document).trigger('diy-editor-appCatalog-loadComplete');
        $(document.body).trigger('AppCatalogOpened.BSA');
    };

    this.showError = function() {
        self.loader.hide();
        self.iframe.css('visibility', 'hidden');
        self.errorContainer.show();
        // remove message event listener
        $(window).unbind('.catalogCrossOrigin');
    };

    this.scheduleErrorDisplay = function() {
        self.timeoutId = setTimeout(function () {
            self.showError();
        }, self.errorDelay);
    };



}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/site-admin/main/controllers/appsCatalog.js
 ** module id = 741
 ** module chunks = 0
 **/